import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleQuestion, addSingleTest, attemptUserList, changeSingleTestStatus, deleteSingleTest, questionList, testList, updateSingleQuestion, updateSingleTest } from "../apis/apiHandler";

export const test = createAsyncThunk(
    "test/list",
    async ( payload , { rejectWithValue }) => {
        try {
            const response = await testList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addTest = createAsyncThunk(
    "test/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleTest(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateTest = createAsyncThunk(
    "test/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleTest(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteTest = createAsyncThunk(
    "test/delete",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await deleteSingleTest(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeTestStatus = createAsyncThunk(
    "test/changeStatus",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await changeSingleTestStatus(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const question = createAsyncThunk(
    "question/list",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await questionList(payload);

            if (response?.code === 200) {
                return response.data;
            } else if (response?.code === 404) {
                return response.data
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addQuestion = createAsyncThunk(
    "question/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleQuestion(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateQuestion = createAsyncThunk(
    "question/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleQuestion(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const attemptUser = createAsyncThunk(
    "test/attempt_user",
    async ( payload , { rejectWithValue }) => {
        try {
            const response = await attemptUserList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    testList: [],
    addTestData: {},
    updateTestData: {},
    deleteTestData: {},
    changeTestStatusData: {},
    questionList: [],
    addQuestionData: {},
    updateQuestionData: {},
    attemptUserList:[],
    error: null,
    success: false,
};

const testSlice = createSlice({
    name: "category",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(test.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(test.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.testList = payload;
                state.success = true;
            })
            .addCase(test.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addTest.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addTest.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addTestData = payload;
                state.success = true;
            })
            .addCase(addTest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateTest.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateTest.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateTestData = payload;
                state.success = true;
            })
            .addCase(updateTest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteTest.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteTest.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteTestData = payload;
                state.success = true;
            })
            .addCase(deleteTest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeTestStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeTestStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeTestStatusData = payload;
                state.success = true;
            })
            .addCase(changeTestStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(question.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(question.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.questionList = payload;
                state.success = true;
            })
            .addCase(question.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addQuestion.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addQuestion.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addQuestionData = payload;
                state.success = true;
            })
            .addCase(addQuestion.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateQuestion.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateQuestion.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateQuestionData = payload;
                state.success = true;
            })
            .addCase(updateQuestion.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(attemptUser.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(attemptUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.attemptUserList = payload;
                state.success = true;
            })
            .addCase(attemptUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default testSlice.reducer;
